import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromCompanySetting from '.';
import { processResolver } from '../efaact-routing/process-resolver';

const log = new LoggingService();

export const CompanySettingRoute: Ng2StateDeclaration = {
    name: 'companysetting',
    url: '/companysetting',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromCompanySetting.CompanySettingFeatureComponent
};
